import styled from 'styled-components'

import { Input } from '../Input'

export const InputPhone = styled(Input)``
